// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T15:48:10.029Z
// Property: The View at Mill Run (ID: 6737460151193396)
// Collections: 37 amenities, 20 floorplans (live), 21 photos, 21 POIs, 3 reviews, 4 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162250",
  "multihub_property_id": "6737460151193396",
  "property_external_id": "875000",
  "property_zillow_url": "https://www.zillow.com/apartments/owings-mills-md/the-view-at-mill-run/5XqwpK/",
  "property_apartments_url": "https://www.apartments.com/the-view-at-mill-run-owings-mills-md/t25dr19",
  "property_google_business_url": "https://www.google.com/maps/place/The+View+at+Mill+Run/data=!4m2!3m1!1s0x0:0x1b8e87a1d0edf2f2?sa=X&ved=2ahUKEwj9kvCYuruSAxXvkiYFHcfKBygQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "18468874345",
  "property_crm_software": "MRI CRM",
  "property_pm_software": "MRI",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-view-at-mill-run",
  "property_name": "The View at Mill Run",
  "property_website_url": "https://www.theviewatmillrun.com/",
  "property_domain": "https://www.theviewatmillrun.com/",
  "property_address": "9755 Mill Centre Drive",
  "property_full_address": "9755 Mill Centre Dr, Owings Mills, MD 21117",
  "property_address_1": "9755 Mill Centre Dr",
  "property_address_2": null,
  "property_address_city": "Owings Mills",
  "property_address_state": "MD",
  "property_address_zip_full": "21117",
  "property_address_zip": "21117",
  "property_address_country": "US",
  "property_address_county": "Baltimore County",
  "property_neighborhood_address": "Outer W Baltimore County",
  "property_address_latitude": "39.4166387",
  "property_address_longitude": "-76.8142496",
  "property_email": "millrun@dolben.com",
  "property_phone": "(410) 902-7303",
  "property_call_tracking_phone": "8447321587",
  "property_company_name": "DOLBEN",
  "property_company_url": "https://www.dolben.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The View at Mill Run in Owings Mills, MD, where modern living meets exceptional comfort. Choose from stylish one and two-bedroom floor plans, and enjoy exclusive amenities including a sparkling pool, fitness center, and inviting clubhouse. Your ideal home awaits—browse our availability or schedule a tour today!",
  "property_long_description": "<p>The View at Mill Run is ideally situated, with easy access to the Owings Mills Metro Station, I-795, I-83, and I-695. Whether it's the changing seasons, bird watching, or deer sightings, there is something for everyone to enjoy. Our apartments Owings Mills, MD offer a variety of shopping, dining and entertainment options. Our apartment community is perfect for people wanting to enjoy the suburban life: lounge by our resort-style pool, or hike through Soldier's Delight, a natural environment area with over 1,900 acres, offering beautiful vistas and hiking trails. You can strengthen your body and soothe your soul at our state-of-the-art 24-hour fitness and yoga room. Our one- and two-bedroom floor plans provide ample space, designer finishes, and fully applianced kitchens, making entertaining a breeze. On top of that, our apartments have outdoor patios, an easy place for you to relax and take a load off. You can see for yourself how much we pride the look of our community by viewing the photos of the apartments. Our pet-friendly community offers many choices that are sure to accommodate your lifestyle, including loft options. Extraordinary defines The View at Mill Run, a community that has everything to meet your lifestyle needs.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
    "public_id": "019d079f-e651-774c-a3e8-001717951c83",
    "storage_key": "property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": "https://media.multihub.io/property/6737460151193396/01a12133-9970-7642-8bd3-b5e76b8558e9.m4v",
  "property_featured_video_media": {
    "public_id": "01a12133-9970-7642-8bd3-b5e76b8558e9",
    "storage_key": "property/6737460151193396/01a12133-9970-7642-8bd3-b5e76b8558e9.m4v",
    "thumbnail_key": "property/6737460151193396/01a12133-9970-7642-8bd3-b5e76b8558e9_thumb.webp",
    "size_bytes": 10654461,
    "classification": "Community",
    "title": "Apartment Community Overview with Drone Footage",
    "description": "Experience our beautiful apartment community from above. This video showcases the exterior, amenities, and overall layout of the property."
  },
  "property_total_units": "375",
  "property_year_built": "2011",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "8.666666666666668",
  "property_admin_fee": "200",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Admin Fee: $200. Application Fee: $50 per applicant",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "The following breeds are strictly prohibited: Rottweiler, Pit Bull (includes: American Pit Bull Terrier, American Staffordshire Terrier, Staffordshire Bull Terrier, American Bulldog, and Bull Terrier), Doberman, Siberian Husky, Akita, Chow, Mastiff, Great Dane, German Shepherd, Dalmatian, Alaskan Malamutes or, any mix of these breeds. For additional information or questions, please contact the leasing office.",
  "property_pet_policy_description": "We are a pet-friendly community! Dogs and cats are permitted - pet rent applies. There are no weight limits for dogs, but we do have breed restrictions.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://idolben.mriprospectconnect.com/875000",
  "property_resident_portal_url": "https://idolben.mriresidentconnect.com/",
  "property_apply_now_url": "https://idolben.mriprospectconnect.com/875000",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a12140-1f27-724b-b330-cf3c52836875.webp",
  "property_primary_logo_media": {
    "alt_text": "The View at Mill Run logo",
    "public_id": "01a12140-1f27-724b-b330-cf3c52836875",
    "storage_key": "property/6737460151193396/01a12140-1f27-724b-b330-cf3c52836875.webp",
    "width": 249,
    "height": 82
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/019d079f-d962-7119-a248-d38ed7f8c4e4.webp",
  "property_secondary_logo_media": {
    "alt_text": "Dolben logo",
    "public_id": "019d079f-d962-7119-a248-d38ed7f8c4e4",
    "storage_key": "property/6737460151193396/019d079f-d962-7119-a248-d38ed7f8c4e4.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a155e8-6018-7390-a60c-9ee9d251bc0e.webp",
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a12145-47b1-70ee-84c4-19fe2b648bf4.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a12145-47b1-70ee-84c4-19fe2b648bf4",
    "storage_key": "property/6737460151193396/01a12145-47b1-70ee-84c4-19fe2b648bf4.webp",
    "width": 249,
    "height": 82
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a12145-3c2b-72c9-b8e4-b51b009a84f3.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a12145-3c2b-72c9-b8e4-b51b009a84f3",
    "storage_key": "property/6737460151193396/01a12145-3c2b-72c9-b8e4-b51b009a84f3.webp",
    "width": 249,
    "height": 82
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162250/019d06ca-ee10-73da-bbff-8e8bec7c587b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162250/01a0e8dd-680d-75c9-beb0-c526714516d5.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#00263d",
  "property_secondary_color": "#5581ad",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#999999",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "762 - 1525",
  "property_sqft_min": "762",
  "property_sqft_max": "1525",
  "property_price_range": "1600 - 2440",
  "property_price_min": "1750",
  "property_price_max": "2145",
  "property_available_units": 23,
  "property_facebook_url": "https://www.facebook.com/theviewatmillrun/",
  "property_instagram_url": "https://www.instagram.com/viewatmillrun/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJQ0RJ8MIXyIkR8vLt0KGHjhs",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": "Apartments in Owings Mills, MD",
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "In the suburbs of Baltimore is the charming community of Owings Mills, Maryland. Get outdoors in Owings Mills and visit Northwest Regional Park. It’s a lovely place to play sports on the open green, walk the trails, and grill out by an array of picnic tables. Owings Mills houses many public and private schools, each being an important asset to the community and its educational focus. After you find your apartment in Owings Mills, there are a few must-try restaurants around town. Test your pallet at Taj Palace for classic Indian eats, or go next door and try Artful Gourmet Bistro, a chic family-owned bar and grill. Famous for its quality southern cuisine, Granny’s is a local favorite and is host to live jazz on Fridays.",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "<p>In the suburbs of Baltimore is the charming community of Owings Mills, Maryland. Get outdoors in Owings Mills and visit Northwest Regional Park. It’s a lovely place to play sports on the open green, walk the trails, and grill out by an array of picnic tables. Owings Mills houses many public and private schools, each being an important asset to the community and its educational focus. After you find your apartment in Owings Mills, there are a few must-try restaurants around town. Test your palate at Taj Palace for classic Indian eats, or go next door and try Artful Gourmet Bistro, a chic family-owned bar and grill. Famous for its quality southern cuisine, Granny’s is a local favorite and is host to live jazz on Fridays.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>There's more to love at The View at Mill Run; The View at Mill Run overlooks Soldier's Delight Natural Environmental Area and over 1,900 acres of natural beauty. Our Owings Mills apartments offer breathtaking views complemented by unmatched onsite amenities. Get a healthy workout in our state of the art fitness room or yoga room, get your grill on poolside, or shoot a game of pool in our clubroom.</p>",
  "property_applynow_blurb": "At The View at Mill Run in Owings Mills, MD, your ideal home awaits! Choose from spacious one and two-bedroom floor plans, perfect for any lifestyle. Enjoy top-notch amenities, including a sparkling pool, vibrant fitness center, and inviting clubhouse. Ready to elevate your living experience? Lease online today!",
  "property_contactus_blurb": "<p>Contact us if you have any questions, for more information, or to schedule your tour of our luxury apartments in Owings Mills, MD.</p>",
  "property_faqs_blurb": "Discover the perfect home at The View at Mill Run in Owings Mills, MD! Explore our spacious one and two-bedroom floor plans designed for comfort and style. Have questions? Browse our FAQs page for answers about our vibrant community and find your ideal living space today!",
  "property_floorplans_blurb": "<p>At the View at Mill Run, our Owings Mills, MD apartments have everything you could desire, offering open layouts with 9' ceilings, walk-in closets and full-size washer and dryers in each home. Our floor plans provide ample space, designer finishes, and fully applianced kitchens making entertaining a breeze. If fresh air is what you want, you'll enjoy breathtaking views overlooking Soldier's Delight from your private patio. The View at Mill Run, a place you're proud to call home. Make sure to go online to either schedule your personal tour or start your application. We are excited to see you.</p>",
  "property_gallery_blurb": "<p>View photos of The View at Mill Run and get introduced to a community that encompasses natural beauty and suburban living in Owings Mills, MD. Our apartments for rent in Owings Mills, MD offer a variety of spacious floor plans, top-notch amenities like our resort-style pool and the outdoor patios, and a perfect location near Soldier's Delight. Our clubhouse, sparkling pool and modern finishes contribute to an unparalleled living experience. Schedule a tour of our community today and be impressed by The View at Mill Run. You can also go online to start your application after you view the photos!</p>",
  "property_interactivemap_blurb": "Welcome to The View at Mill Run in Owings Mills, MD, where your ideal home awaits! Choose from thoughtfully designed one and two-bedroom floor plans, complemented by luxurious amenities like a sparkling pool, state-of-the-art fitness center, and vibrant clubhouse. Utilize our interactive community map to find your perfect apartment today!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "Discover your perfect home at The View at Mill Run in Owings Mills, MD! Explore our spacious one and two-bedroom floor plans tailored for comfortable living. Great friends make great neighbors—refer a friend to our community today and start creating lasting memories together! ",
  "property_residentaccess_blurb": "<p>With convenient 24/7 access, the resident portal makes it easy for you to request maintenance service and pay your rent online. Log in to get started.</p>",
  "property_reviews_blurb": "<p>Check out our resident reviews!</p>",
  "property_created_at": "1752257379070",
  "property_scheduletour_blurb": "Discover your perfect home at The View at Mill Run in Owings Mills, MD! Choose from our spacious one and two-bedroom floor plans designed for comfort and style. Ready to explore? Schedule a tour today and see what our residents have to say about living in our vibrant community!",
  "property_thankyou_blurb": "<p>A community leasing professional will contact you shortly!</p>",
  "property_virtualtours_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like a virtual tour. Take a look around our apartments in Owings Mills, MD - we know you'll love it here!</p>",
  "property_copyright": "2025 All Rights Reserved. The View at Mill Run",
  "property_seo_title_home": "The View at Mill Run | Apartments in Owings Mills, MD",
  "property_seo_description_home": "The View at Mill Run offers pet-friendly apartments in Owings Mills, MD, with luxury 1, 2, & 3-bedroom floor plans and modern amenities. Tour today!",
  "property_seo_title_floorplans": "Floor Plans | Owings Mills Apartments | Baltimore, MD",
  "property_seo_description_floorplans": "The View at Mill Run offers pet-friendly apartments in Owings Mills, MD, and features 1, 2, & 3-bedroom floor plans with modern amenities and a top location.",
  "property_seo_title_amenities": "Amenities | Owings Mills, MD Apartments",
  "property_seo_description_amenities": "The View at Mill Run offers apartments in Owings Mills, MD, with amenities including a fitness center, playground, clubhouse, swimming pool, and more!",
  "property_seo_title_gallery": "Gallery | Apartments Owings Mills, MD",
  "property_seo_description_gallery": "Picture yourself living at The View at Mill Run, offering top apartments in Owings Mills, MD, by viewing the gallery of our amenities & floor plans.",
  "property_seo_title_virtualtours": "Virtual Tour | Apartments for Rent in Owings Mills, MD",
  "property_seo_description_virtualtours": "Virtual tours are available at The View at Mill Run. Take a virtual tour of our amenities and 1, 2, & 3-bedroom apartments in Owings Mills, MD today!",
  "property_seo_title_interactivemap": "Interactive Map | The View at Mill Run Apartments",
  "property_seo_description_interactivemap": "Find your perfect oasis at The View at Mill Run in Owings Mills, MD! With spacious one and two-bedroom floor plans, our community offers a variety of modern amenities including a refreshing pool, a state-of-the-art fitness center, and inviting lounge spaces. Enjoy conveniences like on-site laundry, package service, and 24/7 maintenance. Plus, our interactive community map makes it easy to explore available apartments and find your dream home. Dive into a lifestyle of comfort and convenience today!",
  "property_seo_title_neighborhood": "Neighborhood | Luxury Apartments Owings Mills",
  "property_seo_description_neighborhood": "The View at Mill Run is located in Owings Mills, MD just minutes away from Baltimore, Costco, Wegmans, USPS, Serpentine Trail, and more!",
  "property_seo_title_contact": "Contact Us | Apartments in Owings Mills, MD",
  "property_seo_description_contact": "Contact us to learn more about our 1, 2, & 3-bedroom Owings Mills apartments, amenities, and special offers available at The View at Mill Run!",
  "property_seo_title_faqs": "FAQs | Apartments in Owings Mills, MD",
  "property_seo_description_faqs": "Unlock the secrets of comfortable living at The View at Mill Run in Owings Mills, MD. Our frequently asked questions page is your go-to resource for insights into our versatile one and two-bedroom floor plans, premium amenities like a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Whether you’re curious about on-site maintenance, laundry facilities, or family-friendly playgrounds, we have you covered. Dive into our FAQ section now to gain clarity on what makes our community your perfect home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Owings Mills, MD",
  "property_seo_description_reviews": "Uncover the vibrant life at The View at Mill Run in Owings Mills, MD, where comfort meets convenience. Our diverse selection of one and two-bedroom floor plans pairs perfectly with top-notch amenities, including a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse. With on-site management, laundry facilities, and recreational spaces for all ages, your satisfaction is our priority. Curious about the real experience? See what our residents have to say about their home sweet home!",
  "property_seo_title_applynow": "Apply Now | Owings Mills Apartments | Baltimore, MD",
  "property_seo_description_applynow": "Apply now to one of our 1, 2, & 3-bedroom floor plans using the online leasing portal & find your new home in Owings Mills, MD near Baltimore.",
  "property_seo_title_residentaccess": "Resident Portal | The View at Mill Run",
  "property_seo_description_residentaccess": "The View at Mill Run residents pay rent online, submit maintenance & manage accounts. Login access here.",
  "property_seo_title_referafriend": "Refer A Friend | The View at Mill Run",
  "property_seo_description_referafriend": "\"Share the joy of community living at The View at Mill Run in Owings Mills, MD! Refer a friend today and enjoy exclusive perks together. Great friends make great neighbors—join us for the ideal apartment lifestyle!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The View at Mill Run",
  "property_seo_description_scheduletour": "\"Experience modern living at The View at Mill Run in Owings Mills, MD! Schedule a tour today to explore our spacious apartments, stunning amenities, and vibrant community. Your dream home awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | The View at Mill Run",
  "property_seo_description_privacy": "Discover how The View at Mill Run prioritizes your privacy in Owings Mills, MD. Explore our comprehensive privacy policy to understand how we protect your personal information and ensure a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The View at Mill Run",
  "property_seo_description_accessibility": "\"Discover inclusivity at The View at Mill Run in Owings Mills, MD. Our Accessibility Statement highlights our commitment to digital inclusion and ensuring all residents can fully enjoy our community. Explore how we prioritize accessibility for every individual. We value digital inclusion—join us today!\"",
  "property_seo_title_sitemap": "Sitemap | The View at Mill Run",
  "property_seo_description_sitemap": "Discover a convenient and organized overview of The View at Mill Run in Owings Mills, MD. Navigate our sitemap to explore available amenities, floor plans, and community highlights. Your perfect apartment awaits—view our sitemap today!",
  "property_seo_title_thankyou": "Thank You | The View at Mill Run",
  "property_seo_description_thankyou": "\"Thank you for your interest in The View at Mill Run in Owings Mills, MD! We appreciate your submission and a dedicated team member will reach out shortly to assist you in finding your perfect apartment. Explore exceptional living with stunning views—your new home awaits!\"",
  "property_seo_title_pets": "Pet Policy | The View at Mill Run",
  "property_seo_description_pets": "The View at Mill Run has the best luxury apartments in Owings Mills, MD, with one, two and three-bedroom floor plan options. Tour our community today!",
  "property_updated_at": "1793292474809",
  "amenities": [
    {
      "id": "custom_85b5dee1-5673-4bf8-9ae9-2d3964de7a92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Electric vehicle charging stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f2ac488c-50b1-4306-b6e8-ee08fd004f57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Amazon Hub Package Delivery System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cdfb5581-7bd3-49f1-8235-4a0fc17d83bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Patio with California kitchen and shuffleboard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec65ac01-a294-44ff-bab2-0f644bca2058",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4571f583-da75-44b3-8208-320fe57026f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "24-hour maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f10344b-bf60-4b05-a52b-8c9da0bf0ff6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3af58ee2-856d-4835-b914-7e71381ef1f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Billiards room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd74798c-e416-4ad9-b797-b3e3f9061818",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Car wash and vacuum",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2eb72a2-2996-4d5a-a8a1-82d44ed78e93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse with entertainment room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7608afc-db2d-4d13-b600-ee946f4e7fae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary bike storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_beaefc98-c426-4753-b6c1-df69758039e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Disability access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_638b7057-c73f-46c0-8da1-aed5fc0cb8f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Elevators",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5196ca01-d4f3-4bdc-9dc2-9b560bd6a746",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Garage parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_065b53dd-47e6-4b5a-9372-b60f1a84f4dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Online payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f678064-ef7f-48bf-ba72-7013d4982a03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Online work orders",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b573514-e7db-493a-be79-3c26d9103771",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Professionally landscaped",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d88135b9-631a-44a1-929d-198895f36bdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "State-of-the-art fitness center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ddf13227-ac23-403c-993e-91df87d601ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6fd3665-1633-4c0c-90db-93f89e926c0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Yoga room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4946741c-35fb-45f9-8e86-278dfd174138",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Valet waste",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_19c4e3fb-d777-4c03-80ca-788fcb5428d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Proud affiliate of the NAA",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99f393b7-8523-4238-abaa-569fc1197f22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Professionally managed by DOLBEN",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_428a5d07-efee-4864-9cb9-95733dccb4cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b360a706-58fa-4a37-bb2b-e3454cec58eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet kitchen with stainless steel appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d0c8fdfd-b55c-4a89-8185-d84bd94a05d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Granite countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61bbf649-38a6-4776-96c9-c8282207d7af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl wood plank flooring in living areas*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4970df0a-6fa7-4804-8c5a-b8adf39df6f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Ceramic tile bath surrounds*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_57f128a0-fee7-40a9-8bcd-5cdc554e5c8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Sunrooms available in select homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f3deeeb-1a28-494e-8cea-02dd6cede4e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "9 foot ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02c0f55c-a612-44e2-9fad-3dd21b7b378f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Central air conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd4bf7ba-e2fc-4bc4-9dfe-a323999eeeb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Full size washer/dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d68994c-702a-4be4-82d7-e6c530399b56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Fully applianced kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e758c94d-9b67-4f9c-b59f-725e0ba158b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Private patio or balcony on most homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_680ec332-a7d7-43ec-9376-348e1482cd57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Lofts and dens available on select homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_219f8ddc-f9e0-4de9-96c0-3fbdc901341d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Storage units available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_01567220-a74d-47c7-bd5c-29099b30b559",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Wall-to-wall carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_62f12262-f82a-4c7a-a714-c1710f062459",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "external_id": "false",
      "title": "Furnished Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b23ce4a4-b56c-48a4-b0ba-1369b608c995",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc22-e35c-767f-8e85-809b8fe3440a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
        "public_id": "01a0fc22-e35c-767f-8e85-809b8fe3440a",
        "storage_key": "property/6737460151193396/01a0fc22-e35c-767f-8e85-809b8fe3440a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience style and convenience in this modern kitchen, featuring sleek white cabinetry, elegant granite countertops, and a full suite of stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7609a68a-806f-4279-a196-e6f8e69f78d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc22-e207-77fe-a8fc-849fe438bfd9.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room in an apartment.",
        "public_id": "01a0fc22-e207-77fe-a8fc-849fe438bfd9",
        "storage_key": "property/6737460151193396/01a0fc22-e207-77fe-a8fc-849fe438bfd9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring white cabinets, granite countertops, stainless steel appliances, and an open layout connected to the living area.",
      "link": "false",
      "alt_text": "Modern kitchen and living room in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_436b7ca4-67a9-4c66-b38f-dcfcac799132",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc22-e341-775b-992a-0bb2bc8fbdc7.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, adjacent to a living area with a sofa and balcony access.",
        "public_id": "01a0fc22-e341-775b-992a-0bb2bc8fbdc7",
        "storage_key": "property/6737460151193396/01a0fc22-e341-775b-992a-0bb2bc8fbdc7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table set for four, complemented by plush chairs. The space flows into a comfortable living area with seating and a television, leading to a balcony with lush green views.",
      "link": "false",
      "alt_text": "Dining area with a round table and four chairs, adjacent to a living area with a sofa and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a02b4539-644f-493c-ac09-4137e4eabe11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc22-eb0d-74be-af2b-74405e7ba6e1.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sofa, blue armchair, and balcony access.",
        "public_id": "01a0fc22-eb0d-74be-af2b-74405e7ba6e1",
        "storage_key": "property/6737460151193396/01a0fc22-eb0d-74be-af2b-74405e7ba6e1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this inviting living room featuring a comfortable gray sofa, a stylish blue armchair, and a balcony perfect for enjoying the outdoors. The space is adorned with modern art and a vibrant rug.",
      "link": "false",
      "alt_text": "Modern living room with a gray sofa, blue armchair, and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bf0272d1-66d2-4103-9980-f0e0f3fc7137",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc22-e5eb-7078-a28c-5300db2c2f3e.webp",
      "image_media": {
        "alt_text": "Living room and bedroom in apartment",
        "public_id": "01a0fc22-e5eb-7078-a28c-5300db2c2f3e",
        "storage_key": "property/6737460151193396/01a0fc22-e5eb-7078-a28c-5300db2c2f3e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room with a balcony view, flowing into a well-appointed bedroom. Perfect for comfortable city living.",
      "link": "false",
      "alt_text": "Living room and bedroom in apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9158a59f-95d7-4ec7-b447-69f634a4be75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-0491-7551-a484-7268d6767807.webp",
      "image_media": {
        "alt_text": "King size bed with white linens and decorative pillows in a bright bedroom with modern art.",
        "public_id": "01a0fc23-0491-7551-a484-7268d6767807",
        "storage_key": "property/6737460151193396/01a0fc23-0491-7551-a484-7268d6767807.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in this spacious and elegantly appointed bedroom, featuring a comfortable king-size bed and modern decor.",
      "link": "false",
      "alt_text": "King size bed with white linens and decorative pillows in a bright bedroom with modern art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c83206a-8405-40b1-bd95-7e18561dad89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-09da-7688-b60a-411961710f83.webp",
      "image_media": {
        "alt_text": "Two twin beds with orange and green bedding in a bedroom with a large window.",
        "public_id": "01a0fc23-09da-7688-b60a-411961710f83",
        "storage_key": "property/6737460151193396/01a0fc23-09da-7688-b60a-411961710f83.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring two comfortable twin beds dressed in tasteful green and orange linens, complemented by large windows that invite natural light.",
      "link": "false",
      "alt_text": "Two twin beds with orange and green bedding in a bedroom with a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c9ce8bd-2608-4acc-bbef-7fc0e5fb2fe1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-27ad-721e-9b10-f66f90ceefe3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, dual sinks, and a walk-in shower.",
        "public_id": "01a0fc23-27ad-721e-9b10-f66f90ceefe3",
        "storage_key": "property/6737460151193396/01a0fc23-27ad-721e-9b10-f66f90ceefe3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this elegant bathroom featuring a spacious white vanity with dual sinks, ample counter space, and a walk-in shower. Perfect for relaxation and daily routines.",
      "link": "false",
      "alt_text": "Modern bathroom with white vanity, dual sinks, and a walk-in shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41cef842-b6bd-44a7-bb85-d9e3c95fcd2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-0a5a-771d-9004-88051373525e.webp",
      "image_media": {
        "alt_text": "Balcony with table and chairs overlooking trees and a pool.",
        "public_id": "01a0fc23-0a5a-771d-9004-88051373525e",
        "storage_key": "property/6737460151193396/01a0fc23-0a5a-771d-9004-88051373525e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy morning coffee or evening drinks on your private balcony, complete with a table and chairs. Overlooks lush greenery and a sparkling pool.",
      "link": "false",
      "alt_text": "Balcony with table and chairs overlooking trees and a pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_afb85902-1791-4862-9242-9234329a2b45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-0cb1-721a-bd05-8f2c57faf44b.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with comfortable seating and large windows overlooking greenery.",
        "public_id": "01a0fc23-0cb1-721a-bd05-8f2c57faf44b",
        "storage_key": "property/6737460151193396/01a0fc23-0cb1-721a-bd05-8f2c57faf44b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring ample seating and large windows that offer beautiful views of the surrounding landscape.",
      "link": "false",
      "alt_text": "Spacious lounge area with comfortable seating and large windows overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_88774f23-8b9b-4f58-bf66-88bdcf90b5a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-2036-72b2-9eb8-f3a89f93b45e.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with a large stone fireplace, plush blue sectional sofa, and stylish decor.",
        "public_id": "01a0fc23-2036-72b2-9eb8-f3a89f93b45e",
        "storage_key": "property/6737460151193396/01a0fc23-2036-72b2-9eb8-f3a89f93b45e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our sophisticated community lounge, featuring a grand stone fireplace, ample comfortable seating, and elegant modern design.",
      "link": "false",
      "alt_text": "Modern community lounge area with a large stone fireplace, plush blue sectional sofa, and stylish decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a030c56c-b3fb-4b33-9fae-ae148e8e2a19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-23ef-745b-bd38-f00f31bcb67e.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, seating areas, and kitchen island.",
        "public_id": "01a0fc23-23ef-745b-bd38-f00f31bcb67e",
        "storage_key": "property/6737460151193396/01a0fc23-23ef-745b-bd38-f00f31bcb67e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy resident amenities including a billiards table, comfortable seating areas, and a modern kitchen island in this spacious community lounge.",
      "link": "false",
      "alt_text": "Community lounge with pool table, seating areas, and kitchen island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_36548dc4-6b05-447f-ba14-e9f2d6c09c7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-381a-7401-b11e-622f812f9af8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island and stainless steel appliances",
        "public_id": "01a0fc23-381a-7401-b11e-622f812f9af8",
        "storage_key": "property/6737460151193396/01a0fc23-381a-7401-b11e-622f812f9af8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Sleek and spacious kitchen featuring a granite countertop island with bar seating and stainless steel appliances, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with granite island and stainless steel appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d772b14e-fe22-4d83-9f23-cd1836fee035",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-284c-758f-a7e5-c36874e3b5a2.webp",
      "image_media": {
        "alt_text": "Fitness center with spin bikes, treadmills, and exercise balls.",
        "public_id": "01a0fc23-284c-758f-a7e5-c36874e3b5a2",
        "storage_key": "property/6737460151193396/01a0fc23-284c-758f-a7e5-c36874e3b5a2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, weights, and yoga mats.",
      "link": "false",
      "alt_text": "Fitness center with spin bikes, treadmills, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54903f93-2398-4822-bae6-58c5b10ba8ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-5223-702d-b4a2-48f2b2b039cf.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment.",
        "public_id": "01a0fc23-5223-702d-b4a2-48f2b2b039cf",
        "storage_key": "property/6737460151193396/01a0fc23-5223-702d-b4a2-48f2b2b039cf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, elliptical machines, and a full range of weight training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_180a494b-89c0-493f-9f31-283746bccc50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-4023-763b-bc30-3521c5b01802.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0fc23-4023-763b-bc30-3521c5b01802",
        "storage_key": "property/6737460151193396/01a0fc23-4023-763b-bc30-3521c5b01802.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style outdoor pool, surrounded by comfortable lounge chairs and beautiful apartment buildings. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b160133f-e64e-468c-8f28-965c55f649cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-434b-725e-be53-59fb704651b1.webp",
      "image_media": {
        "alt_text": "Balcony overlooking a sparkling blue swimming pool with lounge chairs and lush green trees in the background.",
        "public_id": "01a0fc23-434b-725e-be53-59fb704651b1",
        "storage_key": "property/6737460151193396/01a0fc23-434b-725e-be53-59fb704651b1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax on your private balcony with a view of the resort-style pool and beautiful natural surroundings. Perfect for enjoying a sunny day.",
      "link": "false",
      "alt_text": "Balcony overlooking a sparkling blue swimming pool with lounge chairs and lush green trees in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f17da827-70ef-4a41-a5b1-8c2d0e531a22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a0fc23-50a7-747c-8fdb-7c9dad7fc8dd.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with built-in grills, lounge chairs, and a pergola.",
        "public_id": "01a0fc23-50a7-747c-8fdb-7c9dad7fc8dd",
        "storage_key": "property/6737460151193396/01a0fc23-50a7-747c-8fdb-7c9dad7fc8dd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community's grilling station, complete with multiple grills, comfortable lounge seating, and a shaded pergola.",
      "link": "false",
      "alt_text": "Outdoor grilling area with built-in grills, lounge chairs, and a pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28c7c15b-8fb8-43fb-8796-982af05a5fdd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/019d47c6-f922-759f-8d72-34830c2d7b5e.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings in front of apartment buildings.",
        "public_id": "019d47c6-f922-759f-8d72-34830c2d7b5e",
        "storage_key": "property/6737460151193396/019d47c6-f922-759f-8d72-34830c2d7b5e.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring slides and swings for all ages.",
      "link": "false",
      "alt_text": "Playground with slides and swings in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e323b970-acbd-4c8a-8fab-15985ad83802",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/019d47c7-0069-76d9-a946-7616b3ddac33.webp",
      "image_media": {
        "alt_text": "Apartment buildings with fall foliage and a winding road leading to the entrance.",
        "public_id": "019d47c7-0069-76d9-a946-7616b3ddac33",
        "storage_key": "property/6737460151193396/019d47c7-0069-76d9-a946-7616b3ddac33.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Experience comfortable living in our apartment community, surrounded by beautiful autumn scenery and well-maintained grounds.",
      "link": "false",
      "alt_text": "Apartment buildings with fall foliage and a winding road leading to the entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7ba9fe2-f549-4d93-a0fb-93e93827fa3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/019d079f-92b1-706c-9809-91456e0252f3.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with tan siding, stone accents, and balconies.",
        "public_id": "019d079f-92b1-706c-9809-91456e0252f3",
        "storage_key": "property/6737460151193396/019d079f-92b1-706c-9809-91456e0252f3.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Stunning exterior view of the apartment building showcasing its modern architecture, balconies, and well-maintained grounds.",
      "link": "false",
      "alt_text": "Exterior of a modern apartment building with tan siding, stone accents, and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e05b3c14-80e7-4f62-a148-aff9a11d83bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Wegmans",
      "poi_type": "Shopping",
      "poi_address": "10100 Reisterstown Rd, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.visitfoundryrow.com/stores/wegmans/",
      "poi_directions_map_url": "https://www.google.com/maps?sca_esv=942fd3e35b187869&rlz=1C1GCEA_enUS1110US1110&uact=5&gs_lp=Egxnd3Mtd2l6LXNlcnAiE3dlZ21hbnMgZm91bmRyeSBNRAoyBRAhGKABMgUQIRigATIFECEYoAEyBRAhGKABMgUQIRigATIFECEYnwUyBRAhGJ8FMgUQIRifBUivFFDTAVijCnABeAGQAQCYAWygAfYBqgEDMi4xuAEDyAEA-AEBmAIEoAKWAsICDRAAGLADGNYEGEcYyQPCAgoQABiwAxjWBBhHwgIOEAAYgAQYsAMYkgMYigXCAgsQLhiABBjHARivAcICBhAAGBYYHsICCxAAGIAEGIYDGIoFwgIIEAAYgAQYogTCAhoQLhiABBjHARivARiXBRjcBBjeBBjgBNgBAcICCBAAGKIEGIkFmAMAiAYBkAYKugYGCAEQARgUkgcDMy4xoAewGA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KZEs3P4LF8iJMbPYqCr6dy8p&daddr=10100+Reisterstown+Rd,+Owings+Mills,+MD+21117",
      "poi_item_slug": "wegmans",
      "poi_latitude": "39.41272379999999",
      "poi_longitude": "-76.7733263",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_1d010d67-1c4f-472a-b52e-ba5d79c60131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "UIta Beauty",
      "poi_type": "Shopping",
      "poi_address": "10020 Reisterstown Rd, Garrison, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.visitfoundryrow.com/stores/ulta/",
      "poi_directions_map_url": "https://www.google.com/maps/dir//10020+Reisterstown+Rd,+Garrison,+MD+21117/@39.4118949,-76.7704648,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x89c8170d84c7328b:0x5f9d6c33d0031924!2m2!1d-76.7704648!2d39.4118949!3e0?entry=ttu",
      "poi_item_slug": "uita-beauty",
      "poi_latitude": "39.4118949",
      "poi_longitude": "-76.7704648",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_8811c286-d180-4870-a271-d7ad9e53b201",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Lowes",
      "poi_type": "Shopping",
      "poi_address": "10280 Mill Run Cir, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lowes.com/store/MD-Owings-Mills/3388",
      "poi_directions_map_url": "https://www.google.com/maps/dir//lowes+mill+station+MD/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89c817981f549795:0xe0f0351f7afc6419?sa=X&ved=1t:3061&ictx=111",
      "poi_item_slug": "lowes",
      "poi_latitude": "39.4077905",
      "poi_longitude": "-76.79130649999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_08472b31-2bc9-4be6-88ca-0c4d68152fa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping",
      "poi_address": "10220 Mill Run Cir #102, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://www.google.com/maps/dir//Marshalls,+10220+Mill+Run+Cir+%23102,+Owings+Mills,+MD+21117/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89c81a418b80e8d3:0x9947a603b16928ff?sa=X&ved=1t:57443&ictx=111",
      "poi_item_slug": "marshalls",
      "poi_latitude": "39.4051445",
      "poi_longitude": "-76.78989469999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_943e29a2-3545-4475-8ed8-e0b4f405b7fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Five Below",
      "poi_type": "Shopping",
      "poi_address": "10246 Mill Run Circle Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.fivebelow.com/md/owings-mills/10246-mill-run-circle",
      "poi_directions_map_url": "https://www.google.com/maps/dir//10246+Mill+Run+Cir,+Owings+Mills,+MD+21117/@39.4048096,-76.788682,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x89c8179a2a516d1b:0xff9d953be2e9343!2m2!1d-76.788682!2d39.4048096!3e0?entry=ttu",
      "poi_item_slug": "five-below",
      "poi_latitude": "39.4048096",
      "poi_longitude": "-76.788682",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_5e0fe9e5-05db-4a9f-818f-a232bea9c4fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Petsmart",
      "poi_type": "Shopping",
      "poi_address": "10240 Mill Run Cir Suite #102, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.petsmart.com/stores/us/md/owings-mills-store3231.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://www.google.com/maps/dir//10240+Mill+Run+Cir+Suite+%23102,+Owings+Mills,+MD+21117/@39.4047375,-76.8714549,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x89c81777a75af00b:0x3ed07b80f784cea7!2m2!1d-76.789054!2d39.4047666?entry=ttu",
      "poi_item_slug": "petsmart",
      "poi_latitude": "39.4047375",
      "poi_longitude": "-76.8714549",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_3fd754fb-d9c6-4295-8ea7-d5c68e0a8584",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Home Sense",
      "poi_type": "Shopping",
      "poi_address": "10220 Mill Run Cir, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.us.homesense.com/md/owings-mills",
      "poi_directions_map_url": "https://www.google.com/maps/dir//Home+Sense+mill+station+maryland/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89c817a385867be9:0xc76e733a20f9e1ea?sa=X&ved=1t:3061&ictx=111",
      "poi_item_slug": "home-sense",
      "poi_latitude": "39.405529",
      "poi_longitude": "-76.79073609999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_3e4c4657-9216-4e1e-b6b2-0ba54ad27529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "The Tillery",
      "poi_type": "Restaurants",
      "poi_address": "10101 Grand Central Ave, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.thetilleryowingsmills.com/",
      "poi_directions_map_url": "https://www.google.com/maps?sca_esv=942fd3e35b187869&rlz=1C1GCEA_enUS1110US1110&uact=5&gs_lp=Egxnd3Mtd2l6LXNlcnAiHmVnZ3NwZWN0YXRpb24gbWlsbCBzdGF0aW9uIE1ECjIFECEYoAEyBRAhGKABMgUQIRigATIFECEYoAEyBRAhGKABMgUQIRirAjIFECEYqwJIhypQnAFYpiJwBHgBkAEAmAGRAaABrQ2qAQQxNi4zuAEDyAEA-AEBmAIXoAKZDsICChAAGLADGNYEGEfCAg0QABiABBiwAxhDGIoFwgIOEAAYsAMY5AIY1gTYAQHCAhkQLhiABBiwAxhDGMcBGMgDGIoFGK8B2AECwgIKEAAYgAQYQxiKBcICDRAAGIAEGLEDGEMYigXCAhAQLhiABBhDGMcBGIoFGK8BwgIFEAAYgATCAgsQLhiABBjHARivAcICGhAuGIAEGMcBGK8BGJcFGNwEGN4EGOAE2AEDwgIIEAAYgAQYsQPCAgsQABiABBiRAhiKBcICBhAAGBYYHsICCxAAGIAEGIYDGIoFwgIOEC4YFhjHARgKGB4YrwHCAggQABiABBiiBMICCBAAGKIEGIkFwgIdEC4YFhjHARgKGB4YrwEYlwUY3AQY3gQY4ATYAQPCAgUQIRifBZgDAIgGAZAGE7oGBggBEAEYCboGBggCEAEYCLoGBggDEAEYFJIHBDE2LjegB52IAQ&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KTfz2dKfF8iJMZQVtKRDCI1f&daddr=10209+Grand+Central+Ave+%23126,+Owings+Mills,+MD+21117",
      "poi_item_slug": "the-tillery",
      "poi_latitude": "39.4057355",
      "poi_longitude": "-76.7798071",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_ec5445ed-7afb-4377-aab2-fb5d9e387529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Eggspectation",
      "poi_type": "Restaurants",
      "poi_address": "10209 Grand Central Ave #126, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.eggspectation.com/pages/owings-mills",
      "poi_directions_map_url": "https://www.google.com/maps?sca_esv=942fd3e35b187869&rlz=1C1GCEA_enUS1110US1110&uact=5&gs_lp=Egxnd3Mtd2l6LXNlcnAiHmVnZ3NwZWN0YXRpb24gbWlsbCBzdGF0aW9uIE1ECjIFECEYoAEyBRAhGKABMgUQIRigATIFECEYoAEyBRAhGKABMgUQIRirAjIFECEYqwJIhypQnAFYpiJwBHgBkAEAmAGRAaABrQ2qAQQxNi4zuAEDyAEA-AEBmAIXoAKZDsICChAAGLADGNYEGEfCAg0QABiABBiwAxhDGIoFwgIOEAAYsAMY5AIY1gTYAQHCAhkQLhiABBiwAxhDGMcBGMgDGIoFGK8B2AECwgIKEAAYgAQYQxiKBcICDRAAGIAEGLEDGEMYigXCAhAQLhiABBhDGMcBGIoFGK8BwgIFEAAYgATCAgsQLhiABBjHARivAcICGhAuGIAEGMcBGK8BGJcFGNwEGN4EGOAE2AEDwgIIEAAYgAQYsQPCAgsQABiABBiRAhiKBcICBhAAGBYYHsICCxAAGIAEGIYDGIoFwgIOEC4YFhjHARgKGB4YrwHCAggQABiABBiiBMICCBAAGKIEGIkFwgIdEC4YFhjHARgKGB4YrwEYlwUY3AQY3gQY4ATYAQPCAgUQIRifBZgDAIgGAZAGE7oGBggBEAEYCboGBggCEAEYCLoGBggDEAEYFJIHBDE2LjegB52IAQ&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KTfz2dKfF8iJMZQVtKRDCI1f&daddr=10209+Grand+Central+Ave+%23126,+Owings+Mills,+MD+21117",
      "poi_item_slug": "eggspectation",
      "poi_latitude": "39.40619",
      "poi_longitude": "-76.78186140000001",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_828935ef-d926-4c1a-ad51-0ec9bbd173a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Crumbl Cookie",
      "poi_type": "Restaurants",
      "poi_address": "10200 Mill Run Cir Suite 102, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://crumblcookies.com/mdowingsmills?gad_source=1&gclid=EAIaIQobChMIhuDVpc7tggMVzUpHAR1TGA9UEAAYASAAEgImk_D_BwE",
      "poi_directions_map_url": "https://crumblcookies.com/mdowingsmills?utm_source=google+business&utm_medium=profile&utm_campaign=CRUMBL-US+%7C+GOOGLE+BUSINESS+%7C+STORE+PAGE+%7C+ONGOING+%7C+CONSIDERATION+%7C+PROFILE",
      "poi_item_slug": "crumbl-cookie",
      "poi_latitude": "39.4057694",
      "poi_longitude": "-76.7921333",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_c39277be-e870-4b95-8121-5dd53b3c2f36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Red Lobster",
      "poi_type": "Restaurants",
      "poi_address": "Restaurant Park, 3 Restaurant Park Dr N, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.redlobster.com/seafood-restaurants/",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1GCEA_enUS1110US1110&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigATIHCAYQIRirAtIBCDQxOTBqMWo0qAIAsAIA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KREJAb-QF8iJMb4uVGPnYwrr&daddr=Restaurant+Park,+3+Restaurant+Park+Dr+N,+Owings+Mills,+MD+21117",
      "poi_item_slug": "red-lobster",
      "poi_latitude": "39.40473660000001",
      "poi_longitude": "-76.79275299999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_1acbe54a-afa7-4352-9d64-13bd221c9651",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "10256 Mill Run Cir, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://pandaexpress.com/",
      "poi_directions_map_url": "https://www.google.com/maps?sca_esv=942fd3e35b187869&rlz=1C1GCEA_enUS1110US1110&si=ACC90nzxXuvVTxP0LpVmnsjMftq4OxTZ_QBHvgcZaeuQyN7Tfq9_0MEmlT25TjmKUmX8cQcDu5TsHFKvFLDBez-t20n942-pk62K9dgpG27KtkozEGMbsOW8RPkLgvweQzoh0I5IlnyluAfpW1TCsVP_flbjCKrlC312dros_cPH1fMMetbOBbAyl4CppGiJOFTNoES7nv80l5_HMwpHsXaon1ZQ8fZR8ZcZDvXth70GJ7jddOAe8idSkVOG-WeuyDD6YHCnpfiuVGeN7yXp8PU6EE0pkXn9VDBGV9LaMqatjyRg53VyoIB-gWnfaWoR-UXfgAIW96oS&biw=1368&bih=719&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=Kbu62E9kF8iJMaF1A21h-1ES&daddr=10256+Mill+Run+Cir,+Owings+Mills,+MD+21117",
      "poi_item_slug": "panda-express",
      "poi_latitude": "39.4060069",
      "poi_longitude": "-76.7874314",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_c21361c8-1b7e-445a-a5a8-97e9ed64a560",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Mod Pizza",
      "poi_type": "Restaurants",
      "poi_address": "10290 Mill Run Cir, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.modpizza.com/usa/md/owings-mills/10290-mill-run-circle",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1GCEA_enUS1110US1110&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigATIHCAYQIRirAtIBCTE1NTcwajFqOagCALACAA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KdvL1n2MF8iJMc50CmceZP7P&daddr=10290+Mill+Run+Cir,+Owings+Mills,+MD+21117",
      "poi_item_slug": "mod-pizza",
      "poi_latitude": "39.4059926",
      "poi_longitude": "-76.79277549999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_8efe494d-cb9b-4cbb-95c7-1848e76be36b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "AMC Movie Theater",
      "poi_type": "Entertainment",
      "poi_address": "10100 Mill Run Cir, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/baltimore/amc-owings-mills-17utm_source=gbp&utm_medium=organic&utm_campaign=10100MillRunCircle",
      "poi_directions_map_url": "https://www.google.com/maps/dir//amc+movie+theater+mill+station+md/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89c817997f91169f:0x3cedca76bc41f049?sa=X&ved=1t:3061&ictx=111",
      "poi_item_slug": "amc-movie-theater",
      "poi_latitude": "39.4065946",
      "poi_longitude": "-76.78504579999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_bc902b2c-9309-4826-854e-2abffe244693",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Hyper Kidz",
      "poi_type": "Entertainment",
      "poi_address": "11460 Cronridge Dr Suite 118, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://baltimore.hyperkidzplay.com/",
      "poi_directions_map_url": "https://www.google.com/maps?s=web&rlz=1C1GCEA_enUS1110US1110&lqi=CgpoeXBlciBraWR6IgOIAQFIiNymx8aygIAIWhwQABABGAAYASIKaHlwZXIga2lkeioGCAIQABABkgERaW5kb29yX3BsYXlncm91bmSqAUIQASoOIgpoeXBlciBraWR6KAAyHhABIhqJNAhn0GFeGBi4ijIg6jtr1MIFUjLIburRiTIOEAIiCmh5cGVyIGtpZHrgAQA&vet=12ahUKEwiYgszlk52GAxVMMVkFHWQhAKUQ1YkKegQIMBAB..i&cs=0&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KU_UTs-YF8iJMcyUrj8ErH7G&daddr=11460+Cronridge+Dr+Suite+118,+Owings+Mills,+MD+21117",
      "poi_item_slug": "hyper-kidz",
      "poi_latitude": "39.4408709",
      "poi_longitude": "-76.7766619",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_cd36e280-a26c-41e5-87a6-c7ca782c501d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Northwest Regional Park",
      "poi_type": "Entertainment",
      "poi_address": "4515 Deer Park Rd, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.baltimorecountymd.gov/departments/recreation/parks-directory/northwest-regional-park",
      "poi_directions_map_url": "https://www.google.com/maps?rlz=1C1GCEA_enUS1110US1110&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzM3MWowajSoAgCwAgA&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KUflayyrIsiJMTpOZB9b1rzG&daddr=4515+Deer+Park+Rd,+Owings+Mills,+MD+21117",
      "poi_item_slug": "northwest-regional-park",
      "poi_latitude": "39.3942162",
      "poi_longitude": "-76.8292896",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_9c0c963f-2dbe-4368-bf9e-3292bfa416e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Title Boxing",
      "poi_type": "Other",
      "poi_address": "10200 Grand Central Ave #104, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://titleboxingclub.com/owings-mills-md/",
      "poi_directions_map_url": "https://www.google.com/maps?sca_esv=942fd3e35b187869&rlz=1C1GCEA_enUS1110US1110&uact=5&gs_lp=Egxnd3Mtd2l6LXNlcnAiE3RpdGxlIGJveGluZyBvd2luZ3MyCxAuGIAEGMcBGK8BMgYQABgWGB4yBhAAGBYYHjILEAAYgAQYhgMYigUyCxAAGIAEGIYDGIoFMgsQABiABBiGAxiKBTIIEAAYgAQYogQyCBAAGIAEGKIEMggQABiABBiiBDIaEC4YgAQYxwEYrwEYlwUY3AQY3gQY4ATYAQFIvyxQAFjeK3AAeAGQAQCYAZIBoAHuBKoBAzMuM7gBA8gBAPgBAZgCBqACmQXCAgsQABiABBiRAhiKBcICBRAAGIAEmAMAugYGCAEQARgUkgcDMy4zoAfOPw&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KXn3sLLQF8iJMXxtb-HtlcAv&daddr=10200+Grand+Central+Ave+%23104,+Owings+Mills,+MD+21117",
      "poi_item_slug": "title-boxing",
      "poi_latitude": "39.4063104",
      "poi_longitude": "-76.7813067",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_b278c581-d26a-4128-908f-b6eab4cded27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Other",
      "poi_address": "10209 Grand Central Ave #110, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.clubpilates.com/location/owingsmills?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://www.google.com/maps/dir//10209+Grand+Central+Ave+%23110,+Owings+Mills,+MD+21117/@39.4065708,-76.8636327,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x89c8179e5015fefd:0xe3582a020ae5535!2m2!1d-76.7815544!2d39.4061047?entry=ttu",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "39.4065708",
      "poi_longitude": "-76.8636327",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_e6738671-0e38-4197-a4dc-e4096d43fcd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Norie",
      "poi_type": "Other",
      "poi_address": "10200 Grand Central Ave Suite 106, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.norielwc.com/",
      "poi_directions_map_url": "https://www.google.com/maps/dir//Norie+owings+MD/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x89c8179e34155555:0xfe93fe39364ac7d8?sa=X&ved=1t:3061&ictx=111",
      "poi_item_slug": "norie",
      "poi_latitude": "39.406366",
      "poi_longitude": "-76.7809891",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_e173153b-ef45-41bc-8d84-a3dbede7ecea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Other",
      "poi_address": " 10256 Mill Run Cir, Owings Mills, MD 21117",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.starbucks.com/store-locator/store/12111/mill-station-owings-mills-10256-mill-run-circle-106-owings-mill-md-211174214",
      "poi_directions_map_url": "https://www.google.com/maps?s=web&rlz=1C1GCEA_enUS1110US1110&lqi=ChNTdGFyYnVja3Mgb3dpbmdzIG1kIgOIAQFI3f-i5OaAgIAIWiUQABABGAAYARgCIhNzdGFyYnVja3Mgb3dpbmdzIG1kKgQIAhAAkgELY29mZmVlX3Nob3CqAUsQASoNIglzdGFyYnVja3MoADIfEAEiG0lsYcsUziWmdhO0M5kcZ_LA-9gJ1t98ERCLoDIXEAIiE3N0YXJidWNrcyBvd2luZ3MgbWS6AQMKAV_gAQA&vet=12ahUKEwi6iaPflJ2GAxXEFVkFHe8DAZ4Q1YkKegQIIxAB..i&cs=0&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KV9FhQbtF8iJMS1hZbn1M6Xj&daddr=10256+Mill+Run+Cir,+Owings+Mills,+MD+21117",
      "poi_item_slug": "starbucks",
      "poi_latitude": "39.4060069",
      "poi_longitude": "-76.7874314",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_9520195c-5b44-4bd8-9521-c2dc64da4ca9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "poi_name": "Old Navy",
      "poi_type": "Shopping & Retail",
      "poi_address": "Anchor 5, 10030 Reisterstown Rd Bldg K, Owings Mills, MD 21117, USA",
      "poi_short_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_long_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a1888e-b83e-722e-8d26-e59f205e5e6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1888e-b83e-722e-8d26-e59f205e5e6d",
        "storage_key": "property/6737460151193396/01a1888e-b83e-722e-8d26-e59f205e5e6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oldnavy.gap.com/stores/md/owingsmills/oldnavy-4510.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4282869170688223689&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-navy",
      "poi_latitude": "39.410694",
      "poi_longitude": "-76.7712821",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 410-363-7069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a1888e-be86-70c2-a037-3b3a9cf72464.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1888e-be86-70c2-a037-3b3a9cf72464",
        "storage_key": "property/6737460151193396/01a1888e-be86-70c2-a037-3b3a9cf72464.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbzlBrg0XyIkRyelXstHObzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    }
  ],
  "office_hours": [
    {
      "id": "custom_647e921e-4df3-4e15-8830-c8952a31dc98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_12a248b2-a0a2-4bcf-854e-dbb4cc7e7176",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_220a1e69-da55-498d-aba4-de5ca842e392",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_4c6f4a6a-4c73-4072-b158-554efc0524a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_b93711c2-039c-4dcf-84ca-dd4ff534a53c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_4da2795a-2fb4-4e48-a838-6318c7aa2149",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_9871b065-f6fc-4257-a005-e393ee92e220",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "day": "SUN",
      "open_time": "12:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_115991712c36b382d7fbc254",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "rating": "5",
      "name": "Krystle Purnell",
      "text": "I recently moved into this community, and I truly love my apartment! The space is beautiful, well-maintained, and the amenities are absolutely amazing. From the overall atmosphere to the convenience of everything offered here, it has exceeded my expectations.\n\nOn move-in day, I realized the initial apartment I selected wasn’t the best fit for me personally. I brought my concerns to Katrina, and she immediately listened with care and professionalism. She involved her property manager, Ashley, and together they were incredibly responsive and solution-oriented.\n\nThe very same day, they worked with me to select another apartment that better suited my needs. Their willingness to accommodate me and ensure I was completely happy truly stood out. What could have been a stressful moment turned into such a smooth and positive experience because of their exceptional customer service.\n\nI’m so grateful for Katrina and Ashley — they genuinely care about their residents. If you’re considering moving here, I highly recommend it. This is a wonderful community with a fantastic team behind it!",
      "date": "2026-02-14",
      "title": "false"
    },
    {
      "id": "ec_ac82ab85768011a402038451",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "rating": "4",
      "name": "Sarah Jackman",
      "text": "After living here for a few years, we've seen management change hands a few times. The current property manager (ashley?) is really on top of making sure notices are timely and accurate, which I appreciate. Maintenance puts in the effort to learn the residents too.\n\nThe property is pretty good at replacing things when it needs it, too. The only thing I didn't like as far as this goes is that they replaced our dishwasher with a new one, but the new model is absolutely terrible and doesn't dry my dishes.\n\nSecurity here is a hit or miss. We have the gated garage, but people buzz others in ALL the time. Plus, more than half the people zip through the garage like it's a race. It's DANGEROUS.\n\nIt often smells like weed, so it kinda sucks if you have asthma since the hallways are all indoors.\n\nThe walls between units are thick enough that you barely hear your neighbors, but noise comes in easily through the front door.\n\nOverall it's not a bad place to live, as long as you're careful in the garage.",
      "date": "2026-03-13",
      "title": "false"
    },
    {
      "id": "ec_6c5753774057f06df6c8816a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "rating": "5",
      "name": "Deirdre Davis",
      "text": "I've lived her going on three years.  The leasing office staff Katrina and Will are excellent.  They are always professional and very courteous.  They make every encounter a very positive experience.",
      "date": "2026-06-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_5d323195-8de4-469b-8aae-8a24760144ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Check out this video of 457-Renovated Trefoil on Realync!",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a10dc2-27b9-77fc-bb80-7ec4f45a8b86.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a10dc2-27b9-77fc-bb80-7ec4f45a8b86",
        "storage_key": "property/6737460151193396/01a10dc2-27b9-77fc-bb80-7ec4f45a8b86.webp",
        "width": 623,
        "height": 350
      },
      "virtual_tour_title": "Trefoil - 1 Bedroom, 1 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://api.realync.com/s/rZzHe51BB"
    },
    {
      "id": "custom_b3701942-6532-4b95-91e4-71b77860ce30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Check out this video of 472-Barberry Renovated on Realync!",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a10dc2-42b1-70f9-89af-07b838312873.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a10dc2-42b1-70f9-89af-07b838312873",
        "storage_key": "property/6737460151193396/01a10dc2-42b1-70f9-89af-07b838312873.webp",
        "width": 3072,
        "height": 1728
      },
      "virtual_tour_title": "Barberry - 2 Bedroom, 2 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://api.realync.com/s/n7vRGoJ5d"
    },
    {
      "id": "custom_1e0ac0ee-54a3-4c9c-9811-612364e17f01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Check out this video of 339-Model-Celsia Renovated on Realync!",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a10dc2-4ffd-717f-b967-ad0a022f1f81.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a10dc2-4ffd-717f-b967-ad0a022f1f81",
        "storage_key": "property/6737460151193396/01a10dc2-4ffd-717f-b967-ad0a022f1f81.webp",
        "width": 623,
        "height": 350
      },
      "virtual_tour_title": "Celsia - 2 Bedroom, 2 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://api.realync.com/s/gwjjMyjLA"
    },
    {
      "id": "custom_cde4716d-569c-4092-92c2-68a695d00b58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Check out this video of 377-Dahlia Renovated on Realync!",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193396/01a10dc2-6596-741f-99d9-7e750bee1995.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a10dc2-6596-741f-99d9-7e750bee1995",
        "storage_key": "property/6737460151193396/01a10dc2-6596-741f-99d9-7e750bee1995.webp",
        "width": 3072,
        "height": 1728
      },
      "virtual_tour_title": "Dahlia - 2 Bedroom, 2 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://api.realync.com/s/ACwRXVWIF"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_308ecb4dbc4a0b25e517b30a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364571",
      "name": "Security Deposit (starting at)",
      "description": "Amount intended to be held through residency that may be applied toward amounts owed at move-out. Refunds processed per application and lease terms.",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_aaf0c351a61b27b1f9adb3fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364573",
      "name": "Pet Rent - Cat",
      "description": "false",
      "amount": 45,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "cats",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3854820d30ccc0ce6a986a35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364574",
      "name": "Garage Parking",
      "description": "false",
      "amount": 35,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_733904ea2dae9123521a4534",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364575",
      "name": "Pet Rent - Dog",
      "description": "false",
      "amount": 45,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "dogs",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3a236d865c598c31e301c6be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364576",
      "name": "Storage",
      "description": "false",
      "amount": 25,
      "amount_max": 100,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Monthly, due at move-in",
      "category": "storage",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_52cd02ab06f9420ffc137d63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364577",
      "name": "Utility - Electric - Third Party",
      "description": "Amount for provision and consumption of electric paid to a third party.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_060e4bfbae4441de8a9c6d0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364578",
      "name": "Utility - Natural Gas - Third Party",
      "description": "Amount for provision and consumption of natural gas paid to a third party.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e0a1d621ed127af9303cc5ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364579",
      "name": "Utility - Water / Sewer",
      "description": "Amount for provision and / or consumption of water and sewer services.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c1b3d8a0837aa15f330a2bd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364580",
      "name": "Application Fee",
      "description": "false",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d9177b92fe8b1335c15ebf55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364581",
      "name": "Valet Living",
      "description": "Trash removal service.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "A mandatory $30 trash fee is already included in the displayed base rent amount",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_afad729e0038e825b0aa690e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364582",
      "name": "Holding Deposit",
      "description": "Refundable if cancelled within three days.",
      "amount": 250,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_e25b4e024c6f5ea0bf2c3763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "engrain",
      "external_id": "364583",
      "name": "Renters Liability Insurance - Third Party",
      "description": "Amount for renters liability insurance obtained through resident's provider of choice.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Varies",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "insurance",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199647a-694c-7559-8ea2-962724a2515a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "dolben-the-view-at-mill-run",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-owings-mills-md",
      "search_query": "pet friendly apartments in Owings Mills MD",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Owings Mills, MD",
      "h2_subtitle": "Discover your new pet-friendly home at The View at Mill Run. Enjoy spacious layouts and amenities perfect for you and your furry companions.",
      "page_copy": "Welcome to The View at Mill Run, offering premier pet-friendly apartments in Owings Mills, MD. Our community ensures both you and your furry friends feel at home with spacious one and two-bedroom floor plans designed for comfort and style. Enjoy strolls around our beautifully landscaped grounds and let your pet bask in the sun in our sunrooms available in select homes.\n\nOur pet-friendly environment is complemented by exclusive amenities like a sparkling pool and a state-of-the-art fitness center perfect for unwinding after a day of play. Plus, with our convenient Amazon Hub Package Delivery System, you and your four-legged friend can relax knowing you’ll never miss a delivery. Experience the blend of luxury and convenience at our pet-friendly apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
        "public_id": "019d079f-e651-774c-a3e8-001717951c83",
        "storage_key": "property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Owings Mills, MD",
      "seo_description": "Find the perfect pet-friendly apartment in Owings Mills, MD, at The View at Mill Run, with ample amenities for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "generator",
      "page_item_url": "apartments-with-swimming-pool-outer-w-baltimore-county",
      "search_query": "apartments with swimming pool in Outer W Baltimore County",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in W Baltimore",
      "h2_subtitle": "Dive into luxury at The View at Mill Run in Outer W Baltimore County. Experience our sparkling pool and modern living features.",
      "page_copy": "Discover premium living at The View at Mill Run, where our apartments with a swimming pool in Outer W Baltimore County offer a refreshing retreat. Nestled in the vibrant Owings Mills area, our community boasts a stunning pool, perfect for relaxation and recreation, providing an idyllic spot to unwind after a busy day.\n\nIn addition to our sparkling pool, residents enjoy a host of amenities, including a modern fitness center and a stylish clubhouse. Select homes also feature sunrooms, allowing you to bask in natural light. With online payments and amenities like a billiards room, luxury living is not just easy, it's enjoyable. Visit us to see why our apartments with a pool are your ideal choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
        "public_id": "019d079f-e651-774c-a3e8-001717951c83",
        "storage_key": "property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Swimming Pool in W Baltimore",
      "seo_description": "Explore The View at Mill Run for luxury apartments with a swimming pool in Outer W Baltimore County, offering resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-21117",
      "search_query": "luxury apartments with in unit laundry in 21117",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry 21117",
      "h2_subtitle": "Experience top-tier living with in-unit laundry at The View at Mill Run, the premier luxury apartments in the heart of the 21117 area.",
      "page_copy": "Welcome to The View at Mill Run in Owings Mills, MD, where luxury meets convenience. Our luxury apartments with in-unit laundry in 21117 offer the ultimate in modern living. Each home is designed with attention to detail, featuring stylish interiors and high-end finishes to make everyday living an absolute pleasure.\n\nIn addition to the convenience of in-unit laundry, our residents enjoy a wide array of amenities, including a sparkling pool and a state-of-the-art fitness center. Discover the perfect blend of comfort and elegance in our thoughtfully designed one and two-bedroom floor plans. With a convenient Owings Mills location in the heart of the 21117 area, The View at Mill Run is an ideal choice for upscale living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
        "public_id": "019d079f-e651-774c-a3e8-001717951c83",
        "storage_key": "property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry in 21117",
      "seo_description": "Discover luxury apartments with in-unit laundry in 21117 at The View at Mill Run. Enjoy modern amenities and premium conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "generator",
      "page_item_url": "apartment-fitness-center-owings-mills",
      "search_query": "apartment with state-of-the-art fitness center Owings Mills",
      "category": "Amenity",
      "h1_title": "Apartments with State-of-the-Art Fitness Center",
      "h2_subtitle": "Stay fit and active at The View at Mill Run in Owings Mills, where our state-of-the-art fitness center complements luxurious apartment living.",
      "page_copy": "Welcome to The View at Mill Run, where our apartments with a state-of-the-art fitness center in Owings Mills elevate your lifestyle. Our community is designed for those who value both comfort and wellness, providing residents access to cutting-edge exercise equipment just steps from their front door.\n\nBeyond fitness, our luxury apartments offer stylish one and two-bedroom layouts equipped with modern amenities, including in-unit laundry, a sparkling pool, and more. Situated in vibrant Owings Mills, The View at Mill Run provides everything you need to maintain an active, healthy lifestyle, ensuring your home is more than just a place to live—it's a place to thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
        "public_id": "019d079f-e651-774c-a3e8-001717951c83",
        "storage_key": "property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Owings Mills",
      "seo_description": "Discover The View at Mill Run's apartments with a state-of-the-art fitness center in Owings Mills, combining luxury living with health and wellness.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "generator",
      "page_item_url": "washer-dryer-apartments-near-mill-centre-drive",
      "search_query": "full size washer dryer apartments near 9755 Mill Centre Drive",
      "category": "Amenity",
      "h1_title": "Apartments with Full Size Washer Dryer",
      "h2_subtitle": "Discover the convenience of full-size washer dryer apartments near 9755 Mill Centre Drive at The View at Mill Run.",
      "page_copy": "At The View at Mill Run, located near 9755 Mill Centre Drive, we offer full-size washer dryer apartments designed to make your life easier and more comfortable. Experience the perfect blend of style and convenience in our luxurious one and two-bedroom apartments, where modern amenities are at your fingertips.\n\nOur residents enjoy a suite of exclusive features, including a sparkling pool, state-of-the-art fitness center, and vibrant clubhouse. In addition, select apartments include sunrooms for added relaxation and natural light. Perfectly positioned in Owings Mills, MD, The View at Mill Run is where convenience meets luxury in a vibrant community setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
        "public_id": "019d079f-e651-774c-a3e8-001717951c83",
        "storage_key": "property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Full Size Washer Dryer Apartments in Owings Mills",
      "seo_description": "Explore The View at Mill Run's full size washer dryer apartments near 9755 Mill Centre Drive for ultimate convenience and luxury.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-owings-mills-md",
      "search_query": "two bedroom apartments owings mills md",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Owings Mills, MD",
      "h2_subtitle": "Explore spacious two-bedroom apartments in the heart of Owings Mills, MD at The View at Mill Run, featuring modern amenities and comfort.",
      "page_copy": "Discover the comfort and luxury of two-bedroom apartments in Owings Mills, MD at The View at Mill Run. Our sophisticated floor plans provide ample space and modern finishes, making your home the perfect retreat. Each residence is equipped with a full-size washer and dryer, ensuring daily convenience and ease of living.\n\nOur community offers an array of amenities, including a sparkling pool and a state-of-the-art fitness center, perfect for relaxation or staying active. The View at Mill Run is located near the best of what Owings Mills has to offer. Visit us today to see why our two-bedroom layouts are the ideal choice for those seeking a blend of style and substance in a vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
        "public_id": "019d079f-e651-774c-a3e8-001717951c83",
        "storage_key": "property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Owings Mills, MD",
      "seo_description": "Find spacious two-bedroom apartments in Owings Mills, MD at The View at Mill Run. Experience modern living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193396",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-outer-west-baltimore",
      "search_query": "one bedroom apartments near outer west baltimore county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near Outer W Baltimore",
      "h2_subtitle": "Located near Outer West Baltimore County, The View at Mill Run offers one-bedroom apartments that combine comfort and modernity.",
      "page_copy": "Step into comfortable living with our one-bedroom apartments near Outer West Baltimore County at The View at Mill Run. Our beautifully designed one-bedroom spaces cater to those seeking elegance and functionality, complete with modern features like full-size washers and dryers.\n\nResidents enjoy exclusive access to a host of amenities, including a sparkling pool, a well-equipped fitness center, and a welcoming clubhouse. Perfectly situated in the bustling environment of Owings Mills, The View at Mill Run provides the ideal setting for a vibrant lifestyle, just a stone's throw from Outer West Baltimore. Schedule a tour today and find your perfect home among our charming one-bedroom units.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
        "public_id": "019d079f-e651-774c-a3e8-001717951c83",
        "storage_key": "property/6737460151193396/019d079f-e651-774c-a3e8-001717951c83.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near Outer W Baltimore",
      "seo_description": "Discover one-bedroom apartments near Outer West Baltimore County at The View at Mill Run, offering modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "dania@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3514"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028658313"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5L7RFPJ6"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://theviewatm.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_cort_lead_form_id",
      "type": "STRING",
      "value": "View_at_Mill_Run_hHCQYKB5OooHP5Ul8BIW"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "18468874345"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/zlpo608npg4"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_mri_tour_scheduler_url",
      "type": "STRING",
      "value": "https://dolben.leadmanagement.mrisoftware.com/schedule/schedProcessor.asp?propID=100013&subID=&refID=100497&logo=1"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkdQd2thVklDc2NyQmoxcWpNS0VBY0E9PSIsInZhbHVlIjoiWk5UdWowVVp2Q0lXWmlvb3BmTmxSQT09IiwibWFjIjoiYjhiMzgxMDA2Y2JhYTUyNmJjZWE2YWFhYTk0ZjgzMDcyZThkNjc2N2VkZGY0YTNmZWRiZTNhNTBiMzI4ODU3OSJ9"
    }
  ],
  "custom_csm": "dania@repli360.com",
  "custom_qb_id": "3514",
  "custom_repli_id": "5028658313",
  "custom_google_gtm_id": "GTM-5L7RFPJ6",
  "custom_ads_subscription": "none",
  "custom_betterbot_script": "<script src=\"https://theviewatm.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_seo_subscription": "essential",
  "custom_cort_lead_form_id": "View_at_Mill_Run_hHCQYKB5OooHP5Ul8BIW",
  "custom_hubspot_company_id": "18468874345",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/zlpo608npg4",
  "custom_website_subscription": "turnkey",
  "custom_mri_tour_scheduler_url": "https://dolben.leadmanagement.mrisoftware.com/schedule/schedProcessor.asp?propID=100013&subID=&refID=100497&logo=1",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkdQd2thVklDc2NyQmoxcWpNS0VBY0E9PSIsInZhbHVlIjoiWk5UdWowVVp2Q0lXWmlvb3BmTmxSQT09IiwibWFjIjoiYjhiMzgxMDA2Y2JhYTUyNmJjZWE2YWFhYTk0ZjgzMDcyZThkNjc2N2VkZGY0YTNmZWRiZTNhNTBiMzI4ODU3OSJ9",
  "custom_audioeye_site_id": "fe5af283-059d-4b55-a5a1-ea5e3c868039",
  "custom_audioeye_site_hash": "678b85f5de9cd719f6e71c7ff89400a3"
};

export const generatedAt = '2026-11-03T15:48:10.029Z';
